import React from 'react'

export default function WebAppIcon({cls}) {
    return (
        <svg className={"animate-pulse w-20 "+cls}
          
            xmlns="http://www.w3.org/2000/svg"
            
            enableBackground="new 0 0 512 512"
            viewBox="0 0 512 512"
        >
            <path
                xmlns="http://www.w3.org/2000/svg"
                fill="#e1effa"
                d="M341.798 441.102L221.862 441.102 237.087 366.972 326.556 366.972z"
                data-original="#e1effa"
            ></path>
            <path
                xmlns="http://www.w3.org/2000/svg"
                fill="#b6d4ed"
                d="M341.798 441.102L326.556 366.972 237.087 366.972 311.227 441.102z"
                data-original="#b6d4ed"
            ></path>
            <path
                xmlns="http://www.w3.org/2000/svg"
                fill="#e1effa"
                d="M189.747 441.11H373.89300000000003V450.096H189.747z"
                data-original="#e1effa"
            ></path>
            <path
                xmlns="http://www.w3.org/2000/svg"
                fill="#34495e"
                d="M62.904 61.905c-6.136 0-11.172 5.048-11.172 11.19V355.77c0 6.167 5.033 11.205 11.172 11.205h437.878c6.157 0 11.218-5.038 11.218-11.205V73.094c0-6.141-5.061-11.19-11.218-11.19H62.904z"
                data-original="#34495e"
            ></path>
            <path
                xmlns="http://www.w3.org/2000/svg"
                fill="#fff"
                d="M74.982 85.142H488.72900000000004V343.702H74.982z"
                data-original="#ffffff"
            ></path>
            <path
                xmlns="http://www.w3.org/2000/svg"
                fill="#ff8e31"
                d="M92.186 99.619H206.654V133.926H92.186z"
                data-original="#ff8e31"
            ></path>
            <g xmlns="http://www.w3.org/2000/svg" fill="#e1effa">
                <path
                    d="M224.64 99.619H474.26599999999996V133.926H224.64z"
                    data-original="#e1effa"
                ></path>
                <path
                    d="M89.457 293.193H474.251V304.536H89.457z"
                    data-original="#e1effa"
                ></path>
                <path
                    d="M89.457 317.948H474.251V329.238H89.457z"
                    data-original="#e1effa"
                ></path>
            </g>
            <g xmlns="http://www.w3.org/2000/svg" fill="#d0e070">
                <path
                    d="M89.457 214.499H203.925V279.805H89.457z"
                    data-original="#d0e070"
                ></path>
                <path
                    d="M224.64 214.499H339.09799999999996V279.805H224.64z"
                    data-original="#d0e070"
                ></path>
                <path
                    d="M359.782 214.499H474.263V279.805H359.782z"
                    data-original="#d0e070"
                ></path>
            </g>
            <path
                xmlns="http://www.w3.org/2000/svg"
                fill="#b8d1e6"
                d="M89.457 147.35H474.251V201.077H89.457z"
                data-original="#b8d1e6"
            ></path>
            <path
                xmlns="http://www.w3.org/2000/svg"
                fill="#2e445c"
                d="M286.208 366.982H62.886c-6.118 0-11.139-5.066-11.139-11.233v-151.67H74.98v139.62h187.95l23.278 23.283z"
                data-original="#2e445c"
            ></path>
            <path
                xmlns="http://www.w3.org/2000/svg"
                fill="#e1effa"
                d="M262.927 343.704H74.98V204.079h39.483c5.688 0 10.898 2.15 14.723 5.88.381.238.717.622 1.052 1.052l3.489 3.489H89.464v65.3h109.558l13.384 13.384H89.462v11.377H223.78l13.384 13.384H89.462v11.282h158.984l14.481 14.477z"
                data-original="#e1effa"
            ></path>
            <path
                xmlns="http://www.w3.org/2000/svg"
                fill="#b8d26e"
                d="M199.02 279.797L89.462 279.797 89.462 214.501 133.724 214.501z"
                data-original="#b8d26e"
            ></path>
            <g xmlns="http://www.w3.org/2000/svg" fill="#c7e0f4">
                <path
                    d="M223.78 304.557L89.462 304.557 89.462 293.18 212.403 293.18z"
                    data-original="#c7e0f4"
                ></path>
                <path
                    d="M248.445 329.22L89.462 329.22 89.462 317.94 237.164 317.94z"
                    data-original="#c7e0f4"
                ></path>
            </g>
            <path
                xmlns="http://www.w3.org/2000/svg"
                fill="#34495e"
                d="M16.806 450.083C7.572 450.083 0 442.525 0 433.253V225.714c0-9.244 7.572-16.824 16.806-16.824h97.623c9.226 0 16.806 7.575 16.806 16.824v207.542c0 9.267-7.58 16.829-16.806 16.829H16.806v-.002z"
                data-original="#34495e"
            ></path>
            <g xmlns="http://www.w3.org/2000/svg" fill="#283a4d">
                <path
                    d="M80.161 432.708a4.006 4.006 0 01-4.006 4.014H55.076c-2.189 0-4.019-1.812-4.019-4.014v-1.692c0-2.189 1.83-4.024 4.019-4.024h21.079c2.237 0 4.006 1.836 4.006 4.024v1.692zM70.477 227.107a4.83 4.83 0 01-4.833 4.851 4.844 4.844 0 01-4.867-4.851 4.843 4.843 0 014.867-4.841c2.685-.003 4.833 2.178 4.833 4.841z"
                    data-original="#283a4d"
                ></path>
            </g>
            <path
                xmlns="http://www.w3.org/2000/svg"
                fill="#5d6d7e"
                d="M67.896 227.107c0 1.267-.986 2.281-2.255 2.281a2.29 2.29 0 01-2.299-2.281c0-1.262 1.042-2.276 2.299-2.276 1.275 0 2.255 1.013 2.255 2.276z"
                data-original="#5d6d7e"
            ></path>
            <path
                xmlns="http://www.w3.org/2000/svg"
                fill="#fff"
                d="M9.531 245.372H121.718V413.656H9.531z"
                data-original="#ffffff"
            ></path>
            <path
                xmlns="http://www.w3.org/2000/svg"
                fill="#ff8e31"
                d="M18.173 253.974H113.123V268.48699999999997H18.173z"
                data-original="#ff8e31"
            ></path>
            <g xmlns="http://www.w3.org/2000/svg" fill="#e1effa">
                <path
                    d="M18.173 389.782H113.123V394.538H18.173z"
                    data-original="#e1effa"
                ></path>
                <path
                    d="M18.173 400.252H113.123V405.00800000000004H18.173z"
                    data-original="#e1effa"
                ></path>
            </g>
            <path
                xmlns="http://www.w3.org/2000/svg"
                fill="#d0e070"
                d="M18.173 309.731H113.123V384.099H18.173z"
                data-original="#d0e070"
            ></path>
            <path
                xmlns="http://www.w3.org/2000/svg"
                fill="#b8d1e6"
                d="M18.173 274.147H113.123V304.073H18.173z"
                data-original="#b8d1e6"
            ></path>
        </svg>
    )
}
